// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.collapse-arrow[data-v-2d8e6fe2] {\r\n  transition: transform 0.3s ease;\n}\n.collapse-arrow-down[data-v-2d8e6fe2] {\r\n  transform: rotate(180deg);\n}\n.right-align[data-v-2d8e6fe2] {\r\n  text-align: right;\r\n  display: block; /* Ensures the text alignment affects the line */\r\n  width: 100%; /* Takes full width to push content to the right */\n}\r\n", ""]);
// Exports
module.exports = exports;
